import Yup from 'utils/validation';

export const newsInitialValues = {
  id: 0,
  title: '',
  subtitle: '',
  author: '',
  link: '',
  description: '',
  image: [],
  banner: [],
  images: [],
};

export const newsValidationSchema = Yup.object().shape({
  id: Yup.number(),
  title: Yup.string().required(),
  subtitle: Yup.string(),
  author: Yup.string(),
  link: Yup.string(),
  description: Yup.string().required(),
  image: Yup.array().min(1).required(),
  banner: Yup.array().min(1).required(),
  images: Yup.array(),
});
